import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import WorkOrderCreateButton from '../../common/WorkOrderCreateButton';

export default function RightActions({ downloadCSV, switchDisplayMode, isDisplayModeActive }) {
	return (
		<>
			<Button
				size="large"
				icon={<DownloadOutlined translate="" />}
				className="inline-block-visible-md"
				onClick={downloadCSV}
			>
				<span className="inline-block-visible-xxl">Export CSV</span>
			</Button>
			<Button.Group size="large" className="inline-block-visible-xxl">
				<Button onClick={() => switchDisplayMode('list')} disabled={isDisplayModeActive('list')}>
					<i className="icons8-font icons8-bulleted-list-2" />
				</Button>
				<Button onClick={() => switchDisplayMode('map')} disabled={isDisplayModeActive('map')}>
					<i className="icons8-font icons8-location-marker" />
				</Button>
			</Button.Group>
			<WorkOrderCreateButton />
		</>
	);
}
